import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import PageTitle from '../../../components/Text/PageTitle';
import AdminOnboardingForm from './components/AdminOnboardingForm';
import Breadcrumbs from '../../../components/Breadcrumbs/Breadcrumbs';
import ArrowLeft from '../../../components/Icons/ArrowLeft';
import useAdminOnboarding from './useAdminOnboarding';

function AdminOnboarding() {
  const [t] = useTranslation();
  const { id } = useParams();
  const { adminData } = useAdminOnboarding(id);
  const theme = useTheme();
  const navigate = useNavigate();

  /**
   * Handle the close action
   */
  const handleClose = () => {
    navigate('/admins');
  };

  return (
    <>
      <Breadcrumbs
        activeLinks={[{ label: t('navbar.adminOnboarding'), url: '/admins' }]}
        disabledLinks={
          id
            ? [adminData ? `${adminData.firstName} ${adminData.lastName}` : 'Loading...']
            : [t('pages.adminOnboarding.title')]
        }
      />
      <Box sx={{ display: 'flex', alignItems: 'center', paddingBottom: '2.75rem' }}>
        <ArrowLeft
          stroke={theme.palette.primary.main}
          style={{ cursor: 'pointer', marginRight: '1rem' }}
          onClick={handleClose}
        />

        {id ? (
          <PageTitle>{t('pages.adminOnboarding.titleEdit')}</PageTitle>
        ) : (
          <PageTitle>{t('pages.adminOnboarding.title')}</PageTitle>
        )}
      </Box>
      <AdminOnboardingForm />
    </>
  );
}

export default AdminOnboarding;
